// extracted by mini-css-extract-plugin
export var layoutContainer = "_4a-0";
export var layoutContainerNoRounding = "_4a-6";
export var layoutContainerOpen = "_4a-5";
export var layoutContainerResizing = "_4a-1";
export var mainContent = "_4a-2";
export var resizeDivider = "_4a-3";
export var slidePanel = "_4a-4";